<template>
  <div class="ly_cont_main_wrapper">
    <div v-if="showContMain" class="ly_cont_main">
      <div class="ly_cont_main_img">
        <img src="/img/convenience_store.png" />
      </div>
      <!-- /.ly_cont_main_img -->
      <div class="ly_cont_main_txt">
        <div class="bl_cont_main">
          <div class="bl_cont_main_txt">
            <span
              v-html="$t('convenience_store_settlement__completion__title')"
            ></span>
          </div>
          <!-- /.bl_cont_main_txt -->
        </div>
        <!-- /.bl_cont_main -->
      </div>
      <!-- /.ly_cont_main_txt -->
    </div>
    <!-- /.ly_cont_main -->

    <div class="ly_purchaseInfo">
      <div class="bl_purchaseInfo_txt">
        <span>
          <img src="/img/exclamation_circle.svg" />
          {{
            $t(
              'convenience_store_settlement__completion__explanation__caption_caution'
            )
          }}
        </span>
        <p>
          {{
            $t('convenience_store_settlement__completion__explanation__title')
          }}
        </p>
      </div>
      <!-- /.bl_purchaseInfo_txt -->
      <div class="bl_purchaseNotes">
        <p>
          {{
            $t('convenience_store_settlement__completion__explanation__body')
          }}
        </p>
      </div>
      <!-- /.bl_purchaseNotes -->
    </div>
    <!-- /.ly_purchaseInfo -->
    <div class="bl_purchasePrecautions">
      <div class="bl_paymentForKonbini">
        <p>
          {{
            $t(
              'convenience_store_settlement__completion__caption_completed_reflection'
            )
          }}
        </p>
        <p>
          {{
            $t(
              'convenience_store_settlement__completion__caption_payment_deadline'
            )
          }}
        </p>
      </div>
      <!-- /.bl_paymentForKonbini -->
    </div>
    <!-- /.bl_purchasePrecautions -->
  </div>
  <!-- /.ly_cont_main_wrapper -->
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class CoinPurchasePending extends Vue {
  @Prop({ default: true })
  showContMain!: boolean
}
</script>

<style scoped>
.ly_cont {
  position: relative;
  height: auto;
  min-height: 100%;
}

.ly_cont_main_wrapper {
  font-family: sans-serif;
  font-size: 14px;
  color: #262626;
}

.ly_cont_main_img {
  padding-top: 8px;
  text-align: center;
  object-fit: contain;
}

.ly_cont_main_txt {
  font-weight: 600;
  padding-top: 30px;
}
.bl_cont_main {
  text-align: center;
}

.bl_cont_main_txt {
  font-size: 20px;
}
.ly_purchaseInfo {
  background-color: #e8e8e8;
  padding-top: 24px;
  padding-bottom: 24px;
  margin: 24px 0px 24px 0px;
  border-radius: 8px;
}

.bl_purchaseInfo_txt {
  font-size: 20px;
  text-align: center;
}

.bl_purchaseInfo_txt img {
  vertical-align: sub;
}

.bl_purchaseInfo_txt span {
  font-size: 14px;
  font-weight: 600;
  color: #ff003d;
}

.bl_purchaseInfo_txt p {
  font-size: 16px;
  padding-top: 20px;
  font-weight: 600;
}

.bl_purchaseNotes {
  margin: 16px 16px 0px 16px;
}

.bl_purchaseNotes p {
  font-size: 12px;
  font-weight: 300;
}

.bl_purchasePrecautions {
  font-size: 12px;
  font-weight: 300;
  color: #808080;
}
</style>
